export default {"src":"/_next/static/media/scope-determination.264e7177.svg","height":512,"width":448,"blurWidth":0,"blurHeight":0};